import { createSelector } from 'reselect';
import { MediaStreamTypes as MEDIA_STREAM_TYPES } from 'playable/dist/src/constants';

const getVideoUrls = props => props.videoUrls;

function toVidiTypes(url, type) {
  if (/mp4/i.test(type)) {
    return { url, type: MEDIA_STREAM_TYPES.MP4, name: /[0-9]+p/i.exec(type)[0] };
  }
  if (/mpd/i.test(type)) {
    return { url, type: MEDIA_STREAM_TYPES.DASH };
  }
  if (/m3u8/i.test(type)) {
    return { url, type: MEDIA_STREAM_TYPES.HLS };
  }
  if (/webm/i.test(type)) {
    return { url, type: MEDIA_STREAM_TYPES.WEBM };
  }
  return null;
}

const getVidiUrls = createSelector([
  getVideoUrls,
], videoUrls => _.map(videoUrls, toVidiTypes));

export default getVidiUrls;



// WEBPACK FOOTER //
// ./src/shared/selectors/vidi-urls.js